import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllHomedecor } from "../../../Redux/App/action";
import { Box } from "@chakra-ui/react";
import { Spinner } from "@chakra-ui/react";
import ProductCard from "../../UI/ProductCard";

const AllHomeDecor = () => {
  const dispatch = useDispatch();
  const { allHomeDecor, isLoading } = useSelector((store) => store.appReducer);
  useEffect(() => {
    dispatch(getAllHomedecor);
  }, [dispatch]);

  const Loader = () => {
    return (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        background="rgba(0, 0, 0, 0.5)"
        zIndex="9999"
      >
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
      </Box>
    );
  };
  if (isLoading) {
    return (
      <Box h={"80vh"}>
        <Loader />
      </Box>
    );
  }

  return (
    <>
      <div className="grid justify-items-center grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {allHomeDecor &&
          allHomeDecor.map((product, i) => {
            return (
              <ProductCard
                key={i}
                title={product.keyWords}
                productId={product.productId}
                productName={product.productName}
                productImage={product.img}
                price={product.priceDetails.price}
                sellingPrice={product.priceDetails.sellingPrice}
                discountPercentage={product.priceDetails.discountPercentage}
                quantityAvailable={product.isAllVariantSoldOut}
                variantId={product?.variants?.[0]?.id}
                sourceMediaId={product.variants[0].sourceMediaId}
                deletedProductId={product.deletedProductId}
              />
            );
          })}
      </div>
    </>
  );
};

export default AllHomeDecor;
